import script from "./PotreeViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PotreeViewer.vue?vue&type=script&setup=true&lang=ts"

import "./PotreeViewer.vue?vue&type=style&index=0&id=7d5fca56&lang=scss"

const __exports__ = script;

export default __exports__